import * as yup from 'yup';
import { SEARCH_FILTER_KEYS } from 'v2/models';

export const ProvidersStepSchema = yup.object().shape({
  filters: yup.object().shape({
    [SEARCH_FILTER_KEYS.exclude_providers]: yup.array().nullable(),
    [SEARCH_FILTER_KEYS.exclude_providers_drm]: yup
      .object()
      .shape({
        is_all: yup.boolean(),
        list: yup
          .array()
          .of(
            yup.object().shape({
              data_vendor_id: yup.number(),
              data_provider_id: yup.number().nullable(),
              name: yup.string().nullable(),
            })
          )
          .nullable(false),
      })
      .nullable(),
  }),
});
